import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Category } from '../../../app/app.interfaces';
import { ApiService } from "../../../services/api.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormHelper } from "../../../helpers/form.helper";
import { IonicHelper } from "../../../helpers/ionic.helper";

@Component({
	selector: 'admin-category',
	templateUrl: 'admin-category.html'
})

export class AdminCategory implements OnInit {

	@Input() category: Category;
	@Output() categoryChange: EventEmitter<Category> = new EventEmitter<Category>();
	@Output() categoryRemove: EventEmitter<Category> = new EventEmitter<Category>();
	
	form: FormGroup;
	edit: boolean = false;

	constructor( private apiService: ApiService,
							 private ionic: IonicHelper,
							 private formBuilder: FormBuilder){
	}

	toggleEdit(show){
		if(show===undefined) this.edit = !this.edit;
		else this.edit=show;
	}

	ngOnInit(): void {
		this.buildForm();
	}

	buildForm(): void{
		this.form = this.formBuilder.group({
			title: [this.category.title, Validators.compose([Validators.minLength(3), Validators.maxLength(100)])],
		});
	}

	submitForm(): void {

		this.ionic.toggleLoader(true);

		if(this.form.valid){

			let updatedCategory = FormHelper.updateObjectWithFormValues(this.category, this.form);

			this.apiService.updateResource(updatedCategory).then((category) => {

				this.category = category;
				this.categoryChange.emit(this.category);
				this.ionic.toggleLoader(false);
				this.ionic.toast('ADMIN.CATEGORIES.UPDATED_TOAST');
				this.edit = false;

			}).catch((err) => {
				console.error(err);
				this.ionic.toggleLoader(false);
				this.ionic.alert('GLOBAL.GENERAL_ERROR');
			});
		}
		else {
			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'ADMIN.CATEGORIES.ERROR',
				'POST_CREATE.TRY_AGAIN',
				'ADMIN.CATEGORIES.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
			);
		}

	}


	deleteCategory(){
		this.ionic.confirm('ADMIN.CATEGORIES.CONFIRM_DELETE_MSG', 'GLOBAL.ARE_YOU_SURE','GLOBAL.DELETE').subscribe((confirmed: boolean) => {
			if(confirmed){
				this.apiService.deleteResource(this.category).then(()=>{

				  this.categoryRemove.emit(this.category);
				  this.ionic.toast('ADMIN.CATEGORIES.DELETED_TOAST');

				}).catch((err) => {
					console.error(err);
					this.ionic.alert('GLOBAL.GENERAL_ERROR');
				});

			}
		});

	}

}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-category/admin-category.ts